/**
 * @description Can be swapped with the primary gray color.
 */

const grayCool = {
  25: "#FCFCFD",
  50: "#F9F9FB",
  100: "#EFF1F5",
  200: "#DCDFEA",
  300: "#B9C0D4",
  400: "#7D89B0",
  500: "#5D6B98",
  600: "#4A5578",
  700: "#404968",
  800: "#30374F",
  900: "#111322",
  950: "#0E101B",
};

export default grayCool;
